module.exports = __webpack_public_path__ + "media/images/badges/sustainable-cities-communities-100-0270d75d8292d523358c95ae28599638.svg";